// extracted by mini-css-extract-plugin
export var carouselContainer = "heroCarousel-module--carouselContainer--2v1vY";
export var carouselInner = "heroCarousel-module--carouselInner--2lYve";
export var carouselItem = "heroCarousel-module--carouselItem--1QNk0";
export var carouselImage = "heroCarousel-module--carouselImage--Ic6dX";